import script from "./description.vue?vue&type=script&lang=ts&setup=true"
export * from "./description.vue?vue&type=script&lang=ts&setup=true"

import "./description.vue?vue&type=style&index=0&id=3541803e&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3541803e"]])

export default __exports__